<script>
  import { navigate } from 'svelte-navigator';

  import { user } from '../stores';
  if ($user.loggedIn) navigate('/teach');

  import Login from '../components/Login.svelte';
  import SignUp from '../components/SignUp.svelte';
  let tab = 'login';
</script>

<div class="columns">
  <div class="column is-one-third-desktop is-offset-one-third">
    <p class="description my-2 has-text-centered">
      Login or sign up to lead a class.
    </p>
    <div class="tabs is-large">
      <ul>
        <li class:is-active={tab == 'login'}>
          <!-- svelte-ignore a11y-missing-attribute -->
          <a on:click={() => (tab = 'login')}>Login</a>
        </li>
        <li class:is-active={tab == 'signup'}>
          <!-- svelte-ignore a11y-missing-attribute -->
          <a on:click={() => (tab = 'signup')}>Sign up</a>
        </li>
      </ul>
    </div>
    {#if tab == 'signup'}
      <SignUp />
    {:else if tab == 'login'}
      <Login />
    {/if}
  </div>
</div>
